import { render, staticRenderFns } from "./zr.vue?vue&type=template&id=48a35ed6&scoped=true"
import script from "./zr.vue?vue&type=script&lang=js"
export * from "./zr.vue?vue&type=script&lang=js"
import style0 from "./zr.vue?vue&type=style&index=0&id=48a35ed6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a35ed6",
  null
  
)

export default component.exports